if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        const root = this.closest(".m-main-product") || document;
        this.mainProductForm = root.querySelector(".m-product-form--main");
        this.mainProductInfo = root.querySelector(".m-main-product--info");
        if (!this.mainProductForm) { this.container.hidden = true; return; }
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.selectedVariantDefault = this.dataset.disableSelectedVariantDefault === "true";
        this.premiumFlow = this.dataset.agPremiumFlow === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = new URLSearchParams(queryString).has("variant");
        if (!hasQueryString && this.selectedVariantDefault && this.variantData && this.variantData.length > 1)
          this.disableSelectedVariantDefault();

        this.init();
        this.setStickyAddToCartHeight();

        this.addEventListener("change", (event) => {
          if (this.hasAttribute("data-ag-pdp-sticky")) {
            this.syncPremiumChange(event);
            return;
          }
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          this.updateButton(true, "", false);
          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut);
          }
        });

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", "100%");
          return;
        }
        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;
        if (buyNowBtn) this.enable_dynamic_checkout = true;
        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;
        const observerRootMargin = this.premiumFlow ? `-${headerHeight}px 0px 0px 0px` : rootMargin;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const showSticky = this.premiumFlow
                  ? !entry.isIntersecting && entry.boundingClientRect.bottom <= (entry.rootBounds ? entry.rootBounds.top : headerHeight)
                  : entry.intersectionRatio !== 1;

                if (showSticky) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }
                document.documentElement.classList[showSticky ? "add" : "remove"]("stick-atc-show");
              });
            },
            { threshold: this.premiumFlow ? 0 : 1, rootMargin: observerRootMargin }
          );
        }

        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");
              if (field.value == "" && field.hasAttribute("required")) {
                hasCustomFieldRequired = true;
              }
            });
          hasCustomFieldRequired &&
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        if (this.hasAttribute("data-ag-pdp-sticky")) {
          this.addEventListener("submit", (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!this.mainAddToCart || this.mainAddToCart.disabled || this.mainAddToCart.classList.contains("disabled")) return;
            const quantity = this.querySelector('[name="quantity"]');
            const mainQuantity = this.mainProductForm.querySelector('[name="quantity"]');
            if (quantity && mainQuantity) mainQuantity.value = quantity.value;
            this.mainAddToCart.click();
          }, true);
          this.mainStateObserver = new MutationObserver(() => this.mirrorMainState());
          this.mainStateObserver.observe(this.mainAddToCart, {attributes:true, attributeFilter:["disabled", "class", "aria-disabled", "aria-busy"], childList:true, subtree:true, characterData:true});
          this.onMainStateChange = () => this.mirrorMainState();
          this.mainProductForm.addEventListener("change", this.onMainStateChange);
          this.mainProductForm.addEventListener("input", this.onMainStateChange);
          this.mirrorMainState();
        }
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      mirrorMainState() {
        const main = this.mainAddToCart, button = this.domNodes.addToCart;
        if (!main || !button) return;
        button.disabled = main.disabled;
        button.classList.toggle("disabled", main.disabled || main.classList.contains("disabled"));
        const source = main.querySelector(".m-add-to-cart--text"), target = button.querySelector(".m-add-to-cart--text");
        if (target) target.textContent = source ? source.textContent : main.textContent;
        const a = this.mainProductForm.querySelector('[name="quantity"]'), b = this.querySelector('[name="quantity"]');
        if (a && b) {
          b.value = a.value;
          for (const name of ["min", "max", "step"]) {
            if (a.hasAttribute(name)) b.setAttribute(name, a.getAttribute(name));
            else b.removeAttribute(name);
          }
        }
      }

      syncPremiumChange(event) {
        if (event.target.name === "quantity") {
          const main = this.mainProductForm.querySelector('[name="quantity"]');
          if (main) { main.value = event.target.value; main.dispatchEvent(new Event("change", {bubbles:true})); }
          return;
        }
        if (event.target.name !== "id") return;
        const variant = this.variantData.find(v => String(v.id) === event.target.value);
        if (!variant) return;
        const root = this.closest(".m-main-product"), picker = root && root.querySelector("variant-picker");
        const choice = root?.querySelector(`[data-ag-box-option][value="${variant.id}"]`);
        if (choice) { choice.checked = true; choice.dispatchEvent(new Event("change", {bubbles:true})); return; }
        if (!picker) return;
        let changed;
        picker.querySelectorAll("[data-picker-field]").forEach((field, i) => {
          const value = variant.options[i];
          const select = field.querySelector("select");
          if (select) { select.value = value; changed = select; }
          else field.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = input.value === value;
            if (input.checked) changed = input;
          });
          field.dataset.selectedValue = value;
        });
        if (changed) changed.dispatchEvent(new Event("change", {bubbles:true}));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mainStateObserver) this.mainStateObserver.disconnect();
        if (this.unsubscribeVariant) this.unsubscribeVariant();
        if (this.onMainStateChange && this.mainProductForm) {
          this.mainProductForm.removeEventListener("change", this.onMainStateChange);
          this.mainProductForm.removeEventListener("input", this.onMainStateChange);
        }
      }

      setObserveTarget() {
        if (this.observer) {
          const target = this.premiumFlow ? this.mainAddToCart : this.mainProductForm;
          this.observer.observe(target);
          this.observeTarget = target;
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
      }

      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(".m-product-option--dropdown-select");
        if (!pickerSelects) return;
        pickerSelects.value = "";
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".sticky-atc-form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > .m-add-to-cart--text');

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
          addButtonText.textContent = window.MinimogStrings.addToCart;
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        this.unsubscribeVariant = window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, (variant) => {
          if (variant) variantInput.value = variant.id;
          if (this.hasAttribute("data-ag-pdp-sticky")) this.mirrorMainState();
        });
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}
